import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class FormContainer extends Component {

  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.state = {
      children: '',
    };
  }

  render() {
    return (
      <div id="formContainer">
        {this.props.children}
      </div>
    );
  }
}

FormContainer.propTypes = {
  children: PropTypes.element,
};
